import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LOGO = '/dailyreps3.png';
const API_BASE = process.env.REACT_APP_API_URL || '';

export default function ParentLogin() {
  const { loginParent } = useAuth();
  const navigate = useNavigate();
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [forgotMode, setForgotMode] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotSent, setForgotSent] = useState(false);
  const [forgotError, setForgotError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await loginParent(email, password);
      navigate('/parent');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/auth/parent-register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, first_name: firstName, last_name: lastName }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Registration failed');
      // Auto-login after registration
      await loginParent(email, password);
      navigate('/parent');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    setForgotError('');
    setForgotLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier: forgotEmail, type: 'parent' }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Something went wrong');
      setForgotSent(true);
    } catch (err) {
      setForgotError(err.message);
    } finally {
      setForgotLoading(false);
    }
  };

  if (forgotMode) {
    return (
      <div className="login-page">
        <img src={LOGO} alt="Train Daily" className="login-logo" />
        <h1 className="login-title"><span>Train Daily</span> Reset Password</h1>
        {forgotSent ? (
          <div style={{ textAlign: 'center', maxWidth: 400 }}>
            <p style={{ color: '#ccc', marginBottom: 20 }}>If an account exists with that email, we sent a password reset link. Check your inbox.</p>
            <button
              onClick={() => { setForgotMode(false); setForgotSent(false); setForgotEmail(''); }}
              style={{ background: 'none', border: 'none', color: '#fff', textDecoration: 'underline', cursor: 'pointer', fontSize: '0.9rem' }}
            >
              Back to login
            </button>
          </div>
        ) : (
          <>
            <form className="login-form" onSubmit={handleForgotSubmit}>
              {forgotError && <div className="login-error">{forgotError}</div>}
              <p style={{ color: '#ccc', fontSize: '0.9rem', marginBottom: 8, textAlign: 'center' }}>Enter your email and we'll send you a reset link.</p>
              <input
                type="email"
                placeholder="Email"
                value={forgotEmail}
                onChange={(e) => setForgotEmail(e.target.value)}
                autoCapitalize="none"
                autoCorrect="off"
                required
              />
              <button className="btn btn-orange" type="submit" disabled={forgotLoading}>
                {forgotLoading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
            <button
              onClick={() => { setForgotMode(false); setForgotError(''); }}
              style={{ background: 'none', border: 'none', color: '#fff', textDecoration: 'underline', cursor: 'pointer', marginTop: 20, fontSize: '0.9rem' }}
            >
              Back to login
            </button>
          </>
        )}
      </div>
    );
  }

  return (
    <div className="login-page">
      <img src={LOGO} alt="Train Daily" className="login-logo" />
      <h1 className="login-title">
        <span>Train Daily</span> {isRegister ? 'Create Account' : 'Parent Login'}
      </h1>
      <form className="login-form" onSubmit={isRegister ? handleRegister : handleLogin}>
        {error && <div className="login-error">{error}</div>}
        {isRegister && (
          <>
            <input
              type="text"
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
            <input
              type="text"
              placeholder="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </>
        )}
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoCapitalize="none"
          autoCorrect="off"
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {isRegister && (
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        )}
        <button className="btn btn-orange" type="submit" disabled={loading}>
          {loading ? (isRegister ? 'Creating Account...' : 'Signing in...') : (isRegister ? 'Create Account' : 'Sign In')}
        </button>
      </form>
      {!isRegister && (
        <button
          onClick={() => { setForgotMode(true); setForgotError(''); setForgotSent(false); setForgotEmail(''); }}
          style={{ background: 'none', border: 'none', color: '#aaa', cursor: 'pointer', marginTop: 14, fontSize: '0.85rem' }}
        >
          Forgot Password?
        </button>
      )}
      <button
        onClick={() => { setIsRegister(!isRegister); setError(''); }}
        style={{ background: 'none', border: 'none', color: '#fff', textDecoration: 'underline', cursor: 'pointer', marginTop: 10, fontSize: '0.9rem' }}
      >
        {isRegister ? 'Already have an account? Sign In' : "Don't have an account? Create one"}
      </button>
    </div>
  );
}
